import { get, post } from '@utils/request';

const preview = 'goods/';
const goodsObj = {};
export const getGoodDetail = params => {
  const id = params.infoId;

  // if(id && goodsObj[id]) return Promise.resolve(goodsObj[id])
  // return get(`${preview}goodsDesc`, params).then(res => {
  //   goodsObj[id] = res
  //   return res
  // })
  return get(`${preview}goodsDesc`, params);
};

//  获取是否拼团商品
export const getGroupBuyGoods = params => get('shop/pt/getPtDetails', params);

//  商品详情页获取拼团信息
export const getGroupBuyAuth = params => get('shop/pt/getPtAuth', params);

//  商品详情页获取拼团信息（未登陆时）
export const getShopPtActivityInfo = params => get('shop/pt/getPtActivityInfo', params);

//  获取互斥商品
export const getMutexGoods = params => get('mutex/rules/mutexGoods', params);

//  领券购，领券接口
export const getCouponBuyInfo = params => get('couponbuy/receiveCoupon', params);

export const getGiveGoodDetail = params => get('shop/order/selectGift', params);

// 联报商品接口
export const getGroupGoodDetail = params => {
  return get('shop/combinat/combinatDesc', params);
};

// 购物车推荐
export const getRecommendGoodDetail = params => get('shop/recommend/recommendConfirm', params);

export const recommendDesc = params => get('shop/recommend/recommendDesc', params);


export const getChannelList = () => get('channel/getChannelList');

export const getGuideInfo = params => get('guide/shopAfterGuide', params);
export const getWXKefuxiaoxi = params => get('wechatJoinGroup/talkingCode', params);

export const getGroupOrderDetail = params => get('shop/combinat/combinatConfirm', params);
export const getCourseComment = params => get('shop/comment/list/v1', params);
export const querySellType = params => get('goods/querySellType', params);

// 投放流程紧迫性组件信息
export const getQueryImmediateStrategyV1 = params => get('goods/queryImmediateStrategy/v1', params);
// 投放流程紧迫性组件信息
export const getPopOpenedV1 = params => get('user/pop/opened/v1', params);

// 投放流程协议开关
export const getProtocolBySellType = params => get('goods/getProtocolBySellType', params);
// 新的 投放流程协议开关
export const getProtocolType = params => get('goods/getProtocolType', params);

// 获取赠品
export const getCourseGift = (params, config) => get('shop/order/getGiftStatus', params, config);

// 获取商品预售信息
export const getPresale = data => post('goods/getPresale', data);
/**
 * 获取用户是否关注了公众号
 * params {
 *  appId: string 公众号APPID(目前只用到了少年得到公众号wx7dff126205e4b443),
 *  unionid: string  用户unionid
 * }
 */
export const getUserSubscribe = params => get('shop/wx/check/user/subscribe', params);

// 查询cms课程目录
export const getCourseDirectoryList = (id) => get('/goods/course/directory/list?infoId=' + id);

// 获取课程详情scame地址
/**
 *
 * @jump {*}  jump  = 1 跳转课程详情页  其他是去书房页面
 * @infoId {*} 商品id
 * @returns
 */
export const getGoodsJumpUrl = (params) => get('/goods/jump/url', params);
/**
 * 公众号模板消息-埋点
 * wechatMsgId
 */
export const getPtReportPtMsg = params => get('shop/pt/reportPtMsg', params);

/**
 * 补差价商品详情
 * goodsId  商品id
 * skuId
 */
export const getCampGoodsDesc = params => get('goods/camp/goods/desc', params);

/**
 * 商品限购数量
 * uid  用户id
 * skuId
 * 返回值： {
 *   stockNum: 用户最大可购买数量
 *   type: 1=库存，2=限购数量
 * }
 */
export const getBuyNum = params => get('goods/getBuyNum', params);